import { useMemo } from 'react';
import { useCategoriesQuery, useVendorsQuery } from '@/client/api/business/spend';
import { useHrDepartmentsQuery } from '@/client/api/hr/people';

export const inputClass =
  'h-9 w-full rounded-md border border-gray-200 bg-white px-3 text-sm outline-none ring-blue-500 focus:ring-2';
export const filterClass = 'h-9 rounded-md border border-gray-200 bg-white px-3 text-sm outline-none ring-blue-500 focus:ring-2';
export const textareaClass = 'w-full rounded-md border border-gray-200 px-3 py-2 text-sm outline-none ring-blue-500 focus:ring-2';

export function Field({ label, children, className = '' }: { label: string; children: React.ReactNode; className?: string }) {
  return (
    <label className={`block space-y-1.5 ${className}`}>
      <span className="text-xs font-medium text-gray-600">{label}</span>
      {children}
    </label>
  );
}

/** Names for the ids spend rows carry. */
export function useSpendLookups() {
  const vendors = useVendorsQuery().data ?? [];
  const categories = useCategoriesQuery().data ?? [];
  const departments = useHrDepartmentsQuery().data ?? [];
  return useMemo(
    () => ({
      vendors,
      categories,
      departments,
      vendorName: (id?: string | null) => vendors.find((v) => v.id === id)?.name ?? '—',
      categoryName: (id?: string | null) => categories.find((c) => c.id === id)?.name ?? '—',
      departmentName: (id?: string | null) => departments.find((d) => d.id === id)?.name ?? '—',
    }),
    [vendors, categories, departments],
  );
}

export const today = () => new Date().toISOString().slice(0, 10);
